<template>
	<div class="per-page-select">
		<v-select
			v-model="selectedPerPage"
			:menu-props="{
				contentClass: 'custom-select-item',
			}"
			:items="options"
			item-title="label"
			item-value="value"
			density="compact"
			hide-details="true"
			variant="outlined"
			class="pg_select"
			@update:model-value="updateList"
		>
		</v-select>
		<em class="mt-2">
			총
			<v-progress-circular
				v-if="total < 0"
				indeterminate
				color="blue-grey-lighten-1"
				:size="10"
				:width="4"
			></v-progress-circular>
			<strong v-else-if="isMaxCount">{{ viewCount }}</strong>
			<strong v-else>{{ total }}</strong>
			건 <em v-if="isMaxCount">이상</em>
			<a v-if="isMaxCount" class="allCount" @click="getTotalCount"
				>전체조회</a
			>
		</em>
	</div>
</template>
<script>
	import { ref, watch } from 'vue';
	export default {
		props: {
			perPage: {
				type: Number,
				required: true,
			},
			total: {
				type: [Number, String],
				required: true,
			},
			patchSize: {
				type: Number,
				default: 0,
				required: false,
			},
		},
		emits: ['update-list', 'total-count'],
		setup(props, { emit }) {
			const selectedPerPage = ref(props.perPage);
			const isMaxCount = ref(false);
			const viewCount = ref(0);
			const options = [
				{ value: 10, label: '10개씩보기' },
				{ value: 30, label: '30개씩보기' },
				{ value: 50, label: '50개씩보기' },
				{ value: 100, label: '100개씩보기' },
				{ value: 200, label: '200개씩보기' },
				{ value: 300, label: '300개씩보기' },
				// { value: 400, label: '400개씩보기' },
				// { value: 500, label: '500개씩보기' },
				// { value: 600, label: '600개씩보기' },
				// { value: 700, label: '700개씩보기' },
				// { value: 800, label: '800개씩보기' },
				// { value: 900, label: '900개씩보기' },
				// { value: 1000, label: '1000개씩보기' },
			];

			// 데이터 변경 시 이벤트 전달
			const updateList = () => {
				emit('update-list', selectedPerPage.value);
			};

			// 전체 조회시 이벤트 전달
			const getTotalCount = () => {
				emit('total-count');
			};

			// props로 받은 perPage 값이 변경될 때 selectedPerPage 갱신
			watch(
				() => props.perPage,
				(newValue) => {
					selectedPerPage.value = newValue;
				},
			);

			watch(
				() => props.total,
				(newValue) => {
					isMaxCount.value = false;
					if (newValue === -1) {
						return;
					}
					const count = Number(newValue.replace(/,/g, ''));
					if (props.patchSize > 0 && count >= props.patchSize) {
						isMaxCount.value = true;
						viewCount.value = newValue.replace(/1$/, '0');
					}
				},
			);

			return {
				selectedPerPage,
				options,
				updateList,
				isMaxCount,
				getTotalCount,
				viewCount,
			};
		},
	};
</script>
<style>
	.allCount {
		margin-left: 10px;
		color: #3e9ddc;
		cursor: pointer;
	}
</style>
